/** @format */

import { Input, Button, DatePicker, message, Popover, Tag, Spin, Upload } from 'antd'
import React, { useEffect, useState } from 'react'
import { UploadToOss } from '../../util/uploadTool';
import { useRef } from 'react'
import { caseReleaseTime, caseAddPopularCase } from '../../api'

// import AliUploader from '../../component/AliUploader/linggan_aliupload'
import './index.less'
import dayjs from 'dayjs'
import moment from 'moment'

const initData = {
  caseId: '',
  cover: '',
  country: '',
  updateTimeString: '',
}

const dirname = 'Popular/'
const imgPrefix = 'https://qingtu-image-originals.oss-cn-shanghai.aliyuncs.com'

const token = {
  host: 'https://image.znzgo.com/',
  ALI_HOST: imgPrefix,
  // access_key_id: 'LTAI5t8ubGymdJDnqyAe2EM2', // oss的key_id
  // access_key_secret: 'zfkvIN3eft7FrYJqfCRDURjGxhSHcF', // oss的secret
  OSS_ENDPOINT: 'oss-cn-shanghai.aliyuncs.com', // 自己oss服务器的配置信息
  OSS_BUCKET: 'qingtu-image-originals', // 自己oss服务器的配置信息
  OSS_REGION: 'oss-cn-shanghai',
}

export default () => {
  const [valueList, setValueList] = useState(new Array(10).fill(initData))
  const [timeList, setTimeList] = useState({})

  const [loading, setLoading] = useState(false)
  const [activeIndex, setActiveIndex] = useState(-1)

  const uploaderInit = useRef({})

  useEffect(() => {
    getCaseReleaseTime()
    // valueList.forEach((item, index) => {
    //   uploaderInit.current[`init${index}`]()
    // })
  }, [])

  const getCaseReleaseTime = () => {
    caseReleaseTime().then((res) => {
      if (res?.error?.code === 0) {
        const newArr = Object.keys(res.data).map((item) => {
          if (res.data[item].length > 0) {
            const timeItem = res.data[item].map((time) =>
              dayjs(time).format('MM-DD')
            )
            return Array.from(new Set(timeItem))
          } else {
            return []
          }
        })
        setTimeList(newArr)
      }
    })
  }

  const handleChangeValue = (index, target, value) => {
    const newData = JSON.parse(JSON.stringify(valueList))

    newData[index][target] = value
    setValueList(newData)
  }

  const resetItem = (index) => {
    const newData = [...valueList]
    newData[index] = initData
    setValueList(newData)
  }

  const handleSubmit = (index) => {
    const { caseId, cover, country, updateTimeString } = valueList[index]
    if (!caseId || !cover || !country || !updateTimeString) {
      message.error('信息未填写全')
      return
    }
    setLoading(true)
    setActiveIndex(index)
    const params = {
      caseId,
      imageUrl: cover,
      showTime: `${updateTimeString} 00:00:00`,
      site: index + 1,
      country,
    }

    caseAddPopularCase(params)
      .then((res) => {
        if (res?.error?.code === 0) {
          message.success('提交成功')
        }
      })
      .catch((err) => {
        message.error('传输错误')
      })
      .finally(() => {
        setActiveIndex(-1)
        setLoading(false)
        getCaseReleaseTime()
      })

    resetItem(index)
  }

  const beforeUpload = (file, index) => {
    const img_type = ['image/png', 'image/jpeg', 'image/jpg', 'image/gif'];
    const img_size = file.size / 1024 / 1024;
    if (!img_type.includes(file.type)) {
      return false;
    }
    if (img_size > 50) {
      return false;
    }

    let reader = new FileReader();
    reader.readAsDataURL(file);
    const OssToken = token;
    reader.onloadend = async () => {
      // 使用ossupload覆盖默认的上传方法
      message.loading('上传中');
      UploadToOss({ token: OssToken }, OssToken.ALI_HOST, file)
        .then((data) => {
          let sourceLink = OssToken.host + '/' + data.name;
          handleChangeValue(
            index,
            'cover',
            sourceLink
          )
          console.debug('data', data)
          message.success('上传成功！')
        })
        .catch((err) => {
          message.destroy();
          message.error('上传失败，请重试~');
        })
        .finally(() => {
          message.destroy();
        });
    };

    return false;
  };
  return (
    <div className='popularContainer'>
      <div className='inputs'>
        {valueList.map((item, index) => (
          <div key={index} className='inputItem'>
            <div className='subTitle'>案例{index + 1}</div>
            <Spin spinning={loading && index === activeIndex}>
              <div className='inputsRow'>
                <div className='label'>ID：</div>
                <Input
                  value={item.caseId}
                  onChange={(e) => {
                    handleChangeValue(index, 'caseId', e.target.value)
                  }}
                  className='idInput'
                />
                <div className='label'>封面图：</div>

                <Upload
                  // {...props}
                  showUploadList={false}
                  beforeUpload={(file) => beforeUpload(file, index)}
                >
                  <Button type='primary'>
                    上传
                  </Button>
                </Upload>
                {/* <Button id={`upload_img_${index}`}>上传</Button> */}
                <div className='imageContainer'>
                  {item.cover && (
                    <Popover
                      trigger='hover'
                      placement='right'
                      content={<img src={item.cover} className='popImg' />}
                    >
                      <img src={item.cover} />
                    </Popover>
                  )}
                </div>
                <div className='label'>国家：</div>
                <Input
                  value={item.country}
                  onChange={(e) => {
                    handleChangeValue(index, 'country', e.target.value)
                  }}
                  className='countryInput'
                />
                <div className='label'>上架时间：</div>
                <DatePicker
                  key={index}
                  value={
                    item.updateTimeString
                      ? moment(item.updateTimeString)
                      : undefined
                  }
                  onChange={(date, datestring) => {
                    handleChangeValue(index, 'updateTimeString', datestring)
                  }}
                />
                <div className='label'>未发布日期：</div>
                <div className='toUpdateTimes'>
                  {timeList[index]?.length > 0 &&
                    timeList[index].map((time, index) => (
                      <Tag
                        className={`releaseTimeItem ${dayjs(item.updateTimeString).format('MM-DD') == time
                          ? 'exist'
                          : ''
                          }`}
                        key={index}
                      >
                        {time}
                      </Tag>
                    ))}
                </div>
                <Button
                  onClick={() => {
                    handleSubmit(index)
                  }}
                >
                  提交
                </Button>
              </div>
            </Spin>

            {/* <AliUploader
              id={`upload_img_${index}`}
              dirname={dirname}
              fileUploaded={(up, file, info, uploaded_object_name) => {
                handleChangeValue(
                  index,
                  'cover',
                  `${imgPrefix}/${uploaded_object_name}`
                )
              }}
              uploaderInit={(func) =>
                (uploaderInit.current[`init${index}`] = func)
              }
              token={token}
            /> */}
          </div>
        ))}
      </div>
    </div>
  )
}
